import React, { useState } from 'react';
import theme from '../../theme';
import useNotificationsStream from './useNotificationsStream';
import NotificationPanel from './NotificationPanel';
import HitTimeline from './HitTimeline';
import useHitFavorites from './useHitFavorites';

const TABS = [
  { key: 'feed', label: 'Feed' },
  { key: 'hits', label: 'Hits' },
];

// `hits` = { asset, account, websocket } turns on the Hits tab for one instrument.
// `framed={false}` drops the card border when a parent (e.g. FolderTabs) already draws one.
// `onSelectItem(n)` makes every item clickable (e.g. to switch to its instrument).
// `page` = the feed is the page's side column: taller list, All/Trades/Errors/More.. filters.
export default function NotificationFeedInline({
  context = {}, title = 'Live feed', hits = null, framed = true, onSelectItem = null, page = false,
  // Several instruments' stars for the Favorites channel (Dashboard Favorites).
  favoriteStars = null,
}) {
  const [filter, setFilter] = useState('all');
  const [tab, setTab] = useState('feed');
  const stream = useNotificationsStream(context, { live: true });
  const { items, unread, loading, load, markAllRead, toggleFlag, remove, clearAll } = stream;

  const { favs, toggleFav } = useHitFavorites(hits?.account, hits?.asset?.broker, hits?.asset?.symbol);

  const tabs = hits && (
    <div className={`ml-2 mr-auto flex shrink-0 gap-1 ${theme.pillContainer}`}>
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => setTab(t.key)}
          className={`rounded-lg px-2 py-0.5 text-[11px] font-medium transition-colors ${tab === t.key ? theme.pillActive : theme.pillInactive}`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className={framed ? `${theme.cardBg} ${theme.cardBorder} rounded-2xl overflow-hidden pb-2` : 'pb-2'}>
      {tab === 'hits' && hits ? (
        <HitTimeline title={title} tabs={tabs} {...hits} favs={favs} toggleFav={toggleFav ?? undefined} />
      ) : (
        <NotificationPanel
          variant={page ? 'page' : 'inline'}
          quickFilters={page}
          favoriteStars={favoriteStars}
          favorites={hits ? favs : null}
          favoritesPair={hits ? `${hits.asset?.broker}|${hits.asset?.symbol}` : null}
          onItemClick={onSelectItem || undefined}
          title={title}
          tabs={tabs}
          items={items}
          loading={loading}
          load={load}
          unread={unread}
          filter={filter}
          setFilter={setFilter}
          onMarkAllRead={markAllRead}
          onToggleFlag={toggleFlag}
          onRemove={remove}
          onClearAll={clearAll}
        />
      )}
    </div>
  );
}
